"use strict";
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.unsubscribeApi = exports.setUserSubscribeApi = exports.removeSaveSearchApi = exports.getSaveSearchCriteriaApi = exports.saveSearchSetsApi = exports.saveSearchCriteriaApi = void 0;
var effects_1 = require("redux-saga/effects");
var EnqueueTokenSaga_1 = require("@/pages/common/sagas/EnqueueTokenSaga");
var SaveSearchApiToken_1 = require("@/api/remote/protected/SaveSearchApiToken");
var stateFilter_1 = require("@/pages/common/sagas/stateFilter");
exports.saveSearchCriteriaApi = function (saveSearchSet) {
    var languageCode;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, effects_1.select(stateFilter_1.getCurrentLanguageCode)];
            case 1:
                languageCode = _a.sent();
                return [4 /*yield*/, effects_1.call(EnqueueTokenSaga_1.enqueueToken, SaveSearchApiToken_1.saveSearchCriteriaToken, saveSearchSet, languageCode)];
            case 2: return [2 /*return*/, _a.sent()];
        }
    });
};
exports.saveSearchSetsApi = function (saveSearchSets) {
    var languageCode;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, effects_1.select(stateFilter_1.getCurrentLanguageCode)];
            case 1:
                languageCode = _a.sent();
                return [4 /*yield*/, effects_1.call(EnqueueTokenSaga_1.enqueueToken, SaveSearchApiToken_1.saveSearchSetsToken, saveSearchSets, languageCode)];
            case 2: return [2 /*return*/, _a.sent()];
        }
    });
};
exports.getSaveSearchCriteriaApi = function () {
    var languageCode;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, effects_1.select(stateFilter_1.getCurrentLanguageCode)];
            case 1:
                languageCode = _a.sent();
                return [4 /*yield*/, effects_1.call(EnqueueTokenSaga_1.enqueueToken, SaveSearchApiToken_1.getSearchCriteriaToken, languageCode)];
            case 2: return [2 /*return*/, _a.sent()];
        }
    });
};
exports.removeSaveSearchApi = function (id) {
    var languageCode;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, effects_1.select(stateFilter_1.getCurrentLanguageCode)];
            case 1:
                languageCode = _a.sent();
                return [4 /*yield*/, effects_1.call(EnqueueTokenSaga_1.enqueueToken, SaveSearchApiToken_1.removeSaveSearchToken, id, languageCode)];
            case 2: return [2 /*return*/, _a.sent()];
        }
    });
};
exports.setUserSubscribeApi = function (state) {
    var languageCode;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, effects_1.select(stateFilter_1.getCurrentLanguageCode)];
            case 1:
                languageCode = _a.sent();
                return [4 /*yield*/, effects_1.call(EnqueueTokenSaga_1.enqueueToken, SaveSearchApiToken_1.setUserSubscribeToken, state, languageCode)];
            case 2: return [2 /*return*/, _a.sent()];
        }
    });
};
exports.unsubscribeApi = function () {
    var languageCode;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, effects_1.select(stateFilter_1.getCurrentLanguageCode)];
            case 1:
                languageCode = _a.sent();
                return [4 /*yield*/, effects_1.call(EnqueueTokenSaga_1.enqueueToken, SaveSearchApiToken_1.unsubscribeToken, languageCode)];
            case 2: return [2 /*return*/, _a.sent()];
        }
    });
};
